/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
* ページローダー
*/
window.addEventListener('load', function () {
	document.querySelector('#main').classList.add('is-show');
	document.querySelector('.page-loader').style.display = 'none';
});

/**
* 検索ボックスアコーディオン
*/
const toggleSearch = document.querySelectorAll('.js-toggleSearch');
for (let i = 0; i < toggleSearch.length; i++) {
	toggleSearch[i].addEventListener('click', () => {
    const content = document.querySelectorAll('.Header__Search-box');
    for (let i = 0; i < content.length; i++) {
      content[i].classList.toggle('is-open');
    }
  });
}

/**
* 検索条件 不要文字列削除
*/
const inputSearch = document.querySelectorAll('.js-inputSearch');
for (let i = 0; i < inputSearch.length; i++) {
	inputSearch[i].addEventListener('change', (e) => {
    e.preventDefault();
    inputSearch[i].nextElementSibling.value = `${inputSearch[i].value.replace(/ /g, '　')} -ct-2 -ct-3 -sct-2 -sct-3 -ct-tassel -sct-tassel`;
  });
}

/**
* 検索ボックス表示判定
*/
if(document.URL.match(/q=/)) {
	const headerSearchBox = document.getElementById('Header__Search-box');
	headerSearchBox.classList.add('is-open');
}